import React from 'react'
import { compose } from 'recompose'
import FullScreen from 'components/wrappers/FullScreen'
import withPreview from 'store/preview/withPreview'
import ViewPage from './ViewPage'

const Previewer = compose(
  withPreview(),
)(
  ({
    isPagePreviewOpened,
    isCanvasPreviewerOpened,
    previewPageId,
    closePreviewer,
  }) => {
    return (
      <FullScreen
        visible={isPagePreviewOpened || isCanvasPreviewerOpened}
        onClose={closePreviewer}
      >
        {({ renderCloseButton }) => (
          <ViewPage
            previewPageId={previewPageId}
            isCanvasPreviewerOpened={isCanvasPreviewerOpened}
            renderCloseButton={renderCloseButton}
          />
        )}
      </FullScreen>
    )
  },
)

Previewer.propTypes = {}
Previewer.defaultProps = {}


export default Previewer



// WEBPACK FOOTER //
// ./src/pages/CustomPages/children/Previewer.js